export default {
  placement: 'QUOTES',
  chatInteractionId: 62858,
  tagMaropost: 'PrePurchase_LastPage_Quotes'
}
